import React from "react";
import "../assets/css/successModal.css";
import SuccessIcon from "../assets/images/success_icon.svg";

const SuccessModal = ({ successModalOpen, closeSuccessModal }) => {
  return (
    <div className={`success-modal ${successModalOpen ? "open" : ""}`}>
      <div className="success-modal-content">
        <img src={SuccessIcon} alt="Success Icon" />
        <h2 className="success-modal-heading">
          Report Submitted Successfully!
        </h2>
        <p className="success-modal-message">
          Your report has been successfully submitted for review.
        </p>
        <button
          className="btn success-modal-button"
          onClick={closeSuccessModal}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
